import { render } from "./InvoiceTermsForm.vue?vue&type=template&id=d1f608ee"
import script from "./InvoiceTermsForm.vue?vue&type=script&lang=js"
export * from "./InvoiceTermsForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__